import { render, staticRenderFns } from "./sidelink.vue?vue&type=template&id=744254c4&"
import script from "./sidelink.vue?vue&type=script&lang=js&"
export * from "./sidelink.vue?vue&type=script&lang=js&"
import style0 from "./sidelink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sidelink.vue"
export default component.exports